import React, { useEffect, useRef, useState, useCallback } from "react";
import { IconArrowUp } from "../../icons/svg";
import Icon from "../../icons/components/Icon";
const Collapse = ({ id, header, children, className = "", defaultOpen = false, isOpen, onToggle, duration = 300, easing = "ease", }) => {
    const controlled = isOpen !== undefined;
    const [openState, setOpenState] = useState(defaultOpen);
    const open = controlled ? !!isOpen : openState;
    // Keep this component compatible with the native TS pass, which does not
    // include DOM lib typings.
    const contentRef = useRef(null);
    // height can be 'auto' or '<n>px'
    const [height, setHeight] = useState(open ? "auto" : "0px");
    // generate a stable id per instance if the user didn't provide one
    // useRef initializer runs only once on mount, so id is stable across renders
    const generatedIdRef = useRef(`collapse-${Math.random().toString(36).slice(2, 9)}`);
    const contentId = id ?? generatedIdRef.current;
    useEffect(() => {
        const el = contentRef.current;
        if (!el)
            return;
        if (open) {
            // expand: animate to measured px then set to auto after the transition
            const measured = `${el.scrollHeight}px`;
            setHeight(measured);
            const t = window.setTimeout(() => setHeight("auto"), duration);
            return () => clearTimeout(t);
        }
        else {
            // collapse: if currently auto -> set px first then to 0 (frames) so transition runs
            if (height === "auto") {
                const px = `${el.scrollHeight}px`;
                setHeight(px);
                requestAnimationFrame(() => requestAnimationFrame(() => setHeight("0px")));
            }
            else {
                setHeight("0px");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, duration]);
    const handleToggle = useCallback(() => {
        if (controlled) {
            onToggle?.(!isOpen);
        }
        else {
            setOpenState((prev) => {
                const next = !prev;
                onToggle?.(next);
                return next;
            });
        }
    }, [controlled, isOpen, onToggle]);
    return (React.createElement("div", { className: `collapse ${open ? "collapse--open" : ""} ${className}` },
        React.createElement("button", { type: "button", className: "collapse__header", "aria-expanded": open, "aria-controls": contentId, onClick: handleToggle },
            React.createElement("span", { className: "collapse__title" }, header),
            React.createElement("span", { className: "collapse__icon", "aria-hidden": "true" },
                React.createElement(Icon, { src: IconArrowUp }))),
        React.createElement("div", { id: contentId, className: "collapse__content", ref: contentRef, style: {
                height: height === "auto" ? undefined : height,
                overflow: "hidden",
                transition: `height ${duration}ms ${easing}`,
            } },
            React.createElement("div", { className: "collapse__inner d-flex flex-direction-column gap-4" }, children))));
};
export default Collapse;
